var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkinginline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  x: 1,
  y: 1,
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.031 7C14.288 7 16 8.318 16 10.44c0 2.075-1.712 3.517-3.969 3.517h-1.364l.01 3.043H8V7zm.016 2.273h-1.37v2.348h1.37c.747 0 1.23-.47 1.23-1.182 0-.697-.483-1.166-1.23-1.166"
}))));
export default SvgParkinginline;